export const LOCAL_MUTATION_EVENT = 'caravan:local-mutation'

export function signalLocalMutation(target?: EventTarget): void {
  const destination = target ?? (typeof window === 'undefined' ? null : window)
  destination?.dispatchEvent(new Event(LOCAL_MUTATION_EVENT))
}
